export default __webpack_public_path__ + "static/media/wb.03266959.jpeg";